var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// x-drawer-panel.ts
import "@adornis/chemistry/elements/components/x-flex.js";
import { customElement } from "lit/decorators.js";
import { XNativeDialog } from "./x-native-dialog.js";
var XDrawerPanel = class extends XNativeDialog {
  constructor() {
    super(...arguments);
    this.animationBehavior = "slideRight";
  }
  static get element_name() {
    if (this === XDrawerPanel)
      return "x-drawer-panel";
    throw new Error(
      "You need to define the element_name getter in order to make x-drawer-panel (static usage) work properly: " + this.name
    );
  }
  get _dialogStyle() {
    return {
      maxWidth: "inherit",
      position: "fixed",
      top: 0,
      bottom: 0,
      right: 0,
      left: "unset",
      height: "100%",
      width: "fit-content",
      margin: "unset",
      maxHeight: "unset"
    };
  }
};
XDrawerPanel = __decorateClass([
  customElement("x-drawer-panel")
], XDrawerPanel);
export {
  XDrawerPanel
};
